/**
 * 拓扑插件-图的交互行为相关常量定义
 */

/**
 * 拓扑插件-定义创建边的交互配置
 * @type attrs 创建边交互配置
 */
export const createEdge = {
  type: 'create-edge',
  trigger: 'drag',
  // key: 'shift',
  edgeConfig: {
    type: 'line',
    style: {
      stroke: '#5d5d5d',
      lineWidth: 1.5,
      shadowColor: '',
      lineDash: [],
      shadowBlur: 0,
      strokeOpacity: 0.8,
      shadowOffsetX: 0,
      shadowOffsetY: 0
    },
    labelCfg: {
      position: 'middle',
      autoRotate: true,
      refX: 0,
      refY: 0,
      style: {
        textAlign: 'center',
        opacity: 1,
        fill: '',
        fontSize: 14,
        stroke: '',
        lineWidth: 0,
        shadowColor: '',
        shadowBlur: 0,
        shadowOffsetX: 0,
        shadowOffsetY: 0
      }
    }
  }
};


/**
 * 拓扑插件-默认行为，一般指查看模式
 * @type array 查看模式行为
 */
export const defaultBehaviorArray = [
  'drag-canvas',
  // 'scroll-canvas',
  'zoom-canvas',
  'drag-node',
  'click-select',
  // 'activate-relations',
  'brush-select',
  'shortcuts-call',
  'drag-combo',
  'collapse-expand-combo',
  'custom-add-node',
  'custom-attribute-handle'
];


/**
 * 拓扑插件-定义常用图形行为
 * @type array 常用行为
 */
export const joinLineBehaviorArray = [
  'drag-canvas',
  // 'scroll-canvas',
  'zoom-canvas',
  'shortcuts-call',
  'drag-combo',
  'collapse-expand-combo',
  createEdge
];




/**
 * 拓扑插件-定义所有图形行为
 * drag-combo：拖动 Combo;
 * collapse-expand-combo：收起和展开 Combo。若图配置有布局，则该 behavior 被触发后会触发图的重新布局。若希望避免重新布局，可以通过监听 combo 点击事件和 graph.collapseExpandCombo API 控制收缩展开逻辑；
 * drag-canvas：拖拽画布；
 * scroll-canvas：滚轮滚动画布，v4.2.6 起支持；
 * zoom-canvas：缩放画布；
 * drag-node：拖拽节点，或拖动 Combo 中的节点；
 * click-select：点击选中节点，再次点击节点或点击 Canvas 取消选中状态；
 * tooltip：节点文本提示；
 * edge-tooltip：边文本提示；
 * activate-relations：当鼠标移到某节点时，突出显示该节点以及与其直接关联的节点和连线；
 * brush-select：拖动框选节点；
 * lasso-select：自由圈选；
 * collapse-expand：只适用于树图，展开或收起子树；若希望在首次布局时有默认收起的子树，则可以在数据中设置子树根节点的属性 collapsed 为 true。若希望使用代码控制子树的展开/收起，同样可以在数据中设置子树根节点的 collapsed 属性，并调用 treeGraph.layout() 使之生效；
 * create-edge：通过交互创建边；
 * shortcuts-call：允许终端用户使用键盘组合键调用 Graph 的函数，例如按下键盘上的 control 与 1，对图进行适应画布。注意：终端用户使用该功能时焦点必须在画布上才能够正确触发；
 * @type array 行为插件组
 */
export const allBehaviorArray = [
  'drag-combo',
  'collapse-expand-combo',
  'drag-canvas',
  'scroll-canvas',
  'zoom-canvas',
  'drag-node',
  'click-select',
  'tooltip',
  'edge-tooltip',
  'activate-relations',
  'brush-select',
  'lasso-select',
  'collapse-expand',
  'create-edge',
  'shortcuts-call'
];

